/**
 * Public marketing CDN (logos / office photos).
 * Amplify must set REACT_APP_PUBLIC_CDN_BASE_URL at build time (include https://).
 */

const DEV_PUBLIC_CDN_FALLBACK = 'https://d1u673rd0558aq.cloudfront.net';

/**
 * Normalize CDN base from env (Amplify sometimes sets host-only without https://).
 */
export const normalizePublicCdnBaseUrl = (raw?: string | null): string => {
  const value = typeof raw === 'string' ? raw.trim() : '';
  if (!value) {
    return DEV_PUBLIC_CDN_FALLBACK;
  }

  const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`;
  return withProtocol.replace(/\/$/, '');
};

/** Resolved at module load from CRA build-time env. */
export const PUBLIC_CDN_BASE_URL = normalizePublicCdnBaseUrl(
  process.env.REACT_APP_PUBLIC_CDN_BASE_URL
);

/** Build a stable public object URL from an S3 object key. */
export const buildPublicCdnObjectUrl = (key?: string | null): string => {
  if (!key || typeof key !== 'string') return '';
  const cleanKey = key.replace(/^\/+/, '');
  if (!cleanKey) return '';
  return `${PUBLIC_CDN_BASE_URL}/${cleanKey}`;
};
